import { render, staticRenderFns } from "./GoogleAddressField.vue?vue&type=template&id=48a45375&lang=pug"
import script from "./GoogleAddressField.vue?vue&type=script&lang=js"
export * from "./GoogleAddressField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports